import { useUserProfile } from '../contexts/UserProfileContext'

/** Profile key the header-ids preference lives under — this UI's own. */
export const SHOW_HEADER_IDS_KEY = 'ruiShowHeaderIds'

/**
 * Whether detail pages show the object's id under the header, set in the
 * preferences and kept in the user profile so it follows the user between
 * browsers. Off by default.
 */
export function useShowHeaderIds() {
  const { read, save } = useUserProfile()
  const showIds = read<unknown>(SHOW_HEADER_IDS_KEY, false) === true

  // Off is the default, so it is stored as no key at all.
  const setShowIds = (next: boolean) => save({ [SHOW_HEADER_IDS_KEY]: next ? true : null })

  return { showIds, setShowIds }
}
